import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbDivider } from '../../types/pbBlocks';
import { parseStyleString, getAdvanced, getIsHidden } from '../utils';

export type DividerType = ContentTypeObject & PbDivider;

/**
 * Aggregates the configuration of a divider element.
 * @param node
 */
export function dividerConfigAggregator(node: CustomHtmlElement): DividerType {
    const childNode = node.childNodes[0] as CustomHtmlElement;
    const style = parseStyleString(node.attributes.style);
    const childStyle = parseStyleString(childNode.attributes.style);

    return {
        ...getAdvanced(node, style),
        ...getIsHidden(style),
        lineColor: childStyle?.borderColor,
        lineWidth: childStyle?.width,
        lineThickness: childStyle?.borderWidth,
        uniqueID: node.attributes['data-pb-style'],
    };
}
